const __ENV__ = globalThis.__ENV__ ?? {}

/** Prefix for the per-flag local overrides, see shared/plugins/posthog/flag-overrides.js */
const POSTHOG_FLAG_PREFIX = 'VITE_POSTHOG_FLAG_'

export const env = {
  /* Runtime variables — read from globalThis.__ENV__ injected by entrypoint.sh (deployed environments)
   * or the Vite dev server middleware (development)
   * Only variables with the prefix VITE_ are injected.
   * New variables must be added inside the argocd project to be available in deployed environments.
   */
  nodeEnv: __ENV__.VITE_NODE_ENV,
  isProduction: __ENV__.VITE_PRODUCTION === 'true',
  logLevel: __ENV__.VITE_LOG_LEVEL,
  isUnifiedCommerce: __ENV__.VITE_IS_UNIFIED_COMMERCE === 'true',
  apiBase: __ENV__.VITE_API_BASE,
  appEnv: __ENV__.VITE_APP_ENV,
  noDevFeatures: __ENV__.VITE_NO_DEV_FEATURES === 'true',
  flatfileLicenseKey: __ENV__.VITE_FLATFILE_LICENSE_KEY,
  posthogToken: __ENV__.VITE_POSTHOG_TOKEN,
  posthogDistinctIdUuidNamespace:
    __ENV__.VITE_POSTHOG_DISTINCT_ID_UUID_NAMESPACE,
  // Every VITE_POSTHOG_FLAG_* variable, keyed by the name after the prefix. Local development
  // only, see shared/plugins/posthog/flag-overrides.js
  posthogFlagEnv: Object.fromEntries(
    Object.entries(__ENV__)
      .filter(([key]) => key.startsWith(POSTHOG_FLAG_PREFIX))
      .map(([key, value]) => [key.slice(POSTHOG_FLAG_PREFIX.length), value])
  ) as Record<string, string>,
  sentryDsn: __ENV__.VITE_SENTRY_DSN,
  keycloakEnabled: __ENV__.VITE_KEYCLOAK_ENABLED,
  keycloakUrl: __ENV__.VITE_KEYCLOAK_URL,
  keycloakRealm: __ENV__.VITE_KEYCLOAK_REALM,
  keycloakClient: __ENV__.VITE_KEYCLOAK_CLIENT,
  onlineBookingUrl: __ENV__.VITE_ONLINE_BOOKING_URL,
  appointmentCalendarUrl: __ENV__.VITE_APPOINTMENT_CALENDAR_URL,
  legacyPrintApiUrl: __ENV__.VITE_LEGACY_PRINT_API_URL,
  legacyPrintPageUrl: __ENV__.VITE_LEGACY_PRINT_PAGE_URL,
  fiskalyCloudApiUrl: __ENV__.VITE_FISKALY_CLOUD_API_URL,
  pliantSsoUrl: __ENV__.VITE_PLIANT_SSO_URL,
  agentChatApiBase: __ENV__.VITE_AGENT_CHAT_API_BASE || __ENV__.VITE_API_BASE,

  // Build-time only — these stay as import.meta.env permanently
  baseUrl: import.meta.env.BASE_URL,
  version: import.meta.env.VITE_VERSION,
  buildDate: import.meta.env.VITE_BUILD_DATE,
  sentryRelease: import.meta.env.VITE_SENTRY_RELEASE
}
